import qs from "qs";
import { omitBy as _omitBy } from "lodash";
import { isJson } from "@/utils/type/JSONUtil";
import { isNIL, NIL } from "@/utils/type/NIL";
import { isBoolean } from "@/utils/type/BooleanUtil";
import { isNumber } from "@/utils/type/NumberUtil";
import { isBlank } from "@/utils/type/StringUtil";

export function paramsSerializer(params) {
  return qs.stringify(omitByCompactRecursive(params), {
    arrayFormat: "repeat",
  });
}

function omitByCompactRecursive(v) {
  if (isJson(v)) {
    return _omitBy(replaceJsonUnableValueToNIL(v), isNIL);
  } else if (Array.isArray(v)) {
    return fillArrayUnableValueToNIL(v).filter((v) => !isNIL(v));
  } else {
    return convertUnableValueToNIL(v);
  }
}

function convertUnableValueToNIL(v) {
  if (isBoolean(v)) {
    return v;
  } else if (isNumber(v)) {
    return v;
  } else if (typeof v === "string" && !isBlank(v)) {
    return v;
  }

  return NIL;
}

function fillArrayUnableValueToNIL(arr) {
  return arr.map(omitByCompactRecursive);
}

function replaceJsonUnableValueToNIL(json) {
  const result = {};

  Object.keys(json).forEach((key) => {
    result[key] = omitByCompactRecursive(json[key]) ?? NIL;
  });

  return result;
}
